import { authFetch } from "~/services/fetch";

export async function makeRequestTogetReportDispatchesStatisticsByommander({ startDate, finishDate, agencyIds, dispatchGroupsIds, groupSetId, userId, exportCSV = false }) {
  try {
    const response = await authFetch({
      url: '/report/dispatches-statistics-by-commander',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        agency_ids: agencyIds,
        dispatch_group_ids: dispatchGroupsIds,
        group_set_id: groupSetId,
        user_id: userId,
        export_csv: exportCSV
      }
    });

    return response.data;

  } catch (error) {
    console.error('ERROR GENERATE REPORT', error)
    throw error
  }
}